import { inject, Injectable } from '@angular/core';
import { HttpService } from '@utils/http.service';

@Injectable({
  providedIn: 'root',
})
export class AntecedenteService {
  private http = inject(HttpService);

  public generateNoPenal = async (body: any) => await this.http.post(`/v1/antecedente/no-penal`, body).then((response: any) => response.data);

  public listNoPenal = async () => await this.http.get(`/v1/antecedente/no-penal`, false).then((response: any) => response.data.content.sort());

  public generateNoInhabilitacion = async (body: any) => await this.http.post(`/v1/antecedente/no-inhabilitacion`, body).then((response: any) => response.data);

  public listNoInhabilitacion = async () => await this.http.get(`/v1/antecedente/no-inhabilitacion`, false).then((response: any) => response.data.content.sort());

  public federalList = async () => await this.http.get(`/v1/antecedente/federal`, false).then((response: any) => response.data.content.sort());
  public federalCreate = async (body: any) => await this.http.post(`/v1/antecedente/federal`, body).then((response: any) => response.data);
}
